// src/components/ProtectedAdminRoute.js

import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function ProtectedAdminRoute({ children }) {
    const [allowed, setAllowed] = useState(null);
    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        const checkAdmin = async () => {
            const user = JSON.parse(localStorage.getItem("user"));
            const token = localStorage.getItem("jwtToken");

            if (!user || !token) {
                Swal.fire({
                    icon: 'error',
                    title: 'Truy cập bị từ chối',
                    text: 'Bạn chưa đăng nhập hoặc phiên đã hết hạn',
                }).then(() => setRedirect(true));
                return;
            }

            try {
                const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/users/${user.userId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (!res.ok) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Truy cập bị từ chối',
                        text: 'Tài khoản không tồn tại hoặc token không hợp lệ',
                    }).then(() => setRedirect(true));
                    return;
                }

                const data = await res.json();

                if (data.role !== "ADMIN") {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Không có quyền',
                        text: 'Chỉ quản trị viên mới được truy cập trang này.',
                    }).then(() => setRedirect(true));
                    return;
                }

                setAllowed(true);
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Lỗi kết nối',
                    text: 'Không thể kiểm tra quyền truy cập.',
                }).then(() => setRedirect(true));
            }
        };

        checkAdmin();
    }, []);

    if (allowed === null && !redirect) return <p>⏳ Đang kiểm tra quyền truy cập...</p>;
    if (redirect) return <Navigate to="/" replace />;
    return children;
}
